export default "__VITE_ASSET__BUUmrttU__"